import React from 'react';
import { translate } from 'react-i18next';
import { Tab, Tabs } from 'react-bootstrap';
import ACCentralGroupsDataTable from './ACCentralGroupsDataTable';

export class MixedUseProjectComponent extends React.Component {
  render() {
    const { t, project } = this.props;
    return (
      <Tabs
        id="mixed-use-project-component-tabs"
        onSelect={key => this.setState({ tabActiveKey: key })}
        mountOnEnter={true}
        defaultActiveKey={1}
      >
        <Tab eventKey={1} title={t('a/c central')}>
          <ACCentralGroupsDataTable 
            projectId={project.id} 
            buildings={project.buildings}
          />
        </Tab>
      </Tabs>
    );
  }
}

export default translate('translations', { withRef: true })(MixedUseProjectComponent);





// WEBPACK FOOTER //
// ./src/components/project_detail/MixedUseProjectComponent.js